import React from "react";
import { NotificationTabHeader, NotificationEmptyState } from "./NotificationTabShared";

/**
 * Placeholder for future connection activity feed.
 * @returns {JSX.Element}
 */
function ActivityTab() {
  return (
    <div>
      <NotificationTabHeader
        title="Activity"
        description="Updates from people you are connected with."
      />
      <NotificationEmptyState
        title="Coming soon"
        subtitle="This feature is under development."
        className="border-solid bg-ui-card"
      />
    </div>
  );
}

export default ActivityTab;
